export const MISSION_STATUS = {
  NOT_STARTED: "missionNotStarted",
  ENDED: "missionEnded",
  PAUSED: "missionPaused",
};

export const FILE_UPLOAD = {
  MAX_SIZE: 15, // MB
  ACCEPTED_TYPES: ".zip,.py,.sb3,.rar,.png,.jpg,.jpeg",
};

export const SUPPORT_EMAIL = "support@codechallenge-championship.org";

export const MCQ_OPTIONS = ["A", "B", "C", "D"];

